import { useMemo, useState } from 'react';
import { GeneralLedgers, VatTypes } from '../library/constants/dynamic.js';
import { defaultSalesLedger, salesLedgersForVat } from '../library/constants/general-ledgers.js';

const toNumber = (value) => {
    const number = parseFloat(value)
    return Number.isFinite(number) ? number : null
}

const findVatType = (vatId) => VatTypes.find(({ id }) => id === vatId)

export const useInvoiceLineTotals = (initialQuantity, initialTotalPriceExclVat, initialVisibleVatId, initialGeneralLedger = null) => {
    const [quantity, setQuantity] = useState(parseInt(initialQuantity) || null);
    const [totalPriceExclVat, setTotalPriceExclVat] = useState(parseFloat(initialTotalPriceExclVat) || null);
    const [visibleVatId, setVisibleVatId] = useState(initialVisibleVatId);
    const [generalLedger, setGeneralLedger] = useState(
        () => initialGeneralLedger ?? defaultSalesLedger(salesLedgersForVat(GeneralLedgers, findVatType(initialVisibleVatId)))?.id ?? null
    )

    const generalLedgerOptions = useMemo(() => {
        const candidates = salesLedgersForVat(GeneralLedgers, findVatType(visibleVatId))
        // Keep a line's existing ledger visible even if it's outside the VAT's bucket.
        const current = GeneralLedgers.find(({ id }) => id === generalLedger)
        return current && !candidates.includes(current) ? [current, ...candidates] : candidates
    }, [visibleVatId, generalLedger])

    // Changing the VAT moves the ledger to that VAT's default unless the chosen one still fits.
    const changeVisibleVatId = (vatId) => {
        setVisibleVatId(vatId)
        const candidates = salesLedgersForVat(GeneralLedgers, findVatType(vatId))
        if (!candidates.some(({ id }) => id === generalLedger)) {
            setGeneralLedger(defaultSalesLedger(candidates)?.id ?? null)
        }
    }

    const vatRate = toNumber(findVatType(visibleVatId)?.percentage)
    const exclVat = toNumber(totalPriceExclVat)
    const qty = toNumber(quantity)
    const totalVat = exclVat !== null && vatRate !== null ? exclVat * vatRate / 100 : null
    const totalPriceInclVat = totalVat !== null ? exclVat + totalVat : null
    const unitPrice = exclVat !== null && qty ? exclVat / qty : null

    return {
        quantity,
        setQuantity,
        totalPriceExclVat,
        setTotalPriceExclVat: (val) => setTotalPriceExclVat(parseFloat(val) || null),
        visibleVatId,
        setVisibleVatId: changeVisibleVatId,
        totalPriceInclVat,
        totalVat,
        unitPrice,
        generalLedger,
        setGeneralLedger,
        generalLedgerOptions,
    };
}
